import { rutas } from "../globales/componentes/menu/rutas";
import type { IRuta } from "../globales/interfaces";


/**
 * Obtiene la primera ruta activa de la lista de rutas
 * @returns La primera ruta activa o null si no hay ninguna activa
 */
export const obtenerPrimeraRutaActiva = (): IRuta | null => {
    return rutas.find(ruta => ruta.Activa) || null;
};

/**
 * Obtiene la primera ruta activa que el usuario puede acceder según sus permisos
 * @param puedeAccederModulo - Función para verificar permisos de acceso a módulos
 * @returns La primera ruta activa y accesible o null si no hay ninguna
 */
export const obtenerPrimeraRutaAccesible = (puedeAccederModulo: (permiso?: string) => boolean): IRuta | null => {
    return rutas.find(ruta => ruta.Activa && puedeAccederModulo(ruta.PermisoRequerido)) || null;
};

/**
 * Obtiene la ruta por defecto para redirección después del login
 * @param puedeAccederModulo - Función para verificar permisos de acceso a módulos
 * @returns La ruta por defecto o '/proyectos' como fallback
 */
export const obtenerRutaPorDefecto = (puedeAccederModulo?: (permiso?: string) => boolean): string => {
    if (puedeAccederModulo) {
        const primeraRutaAccesible = obtenerPrimeraRutaAccesible(puedeAccederModulo);
        return primeraRutaAccesible ? primeraRutaAccesible.Ruta : '/proyectos';
    }
    
    // Fallback para cuando no se pasa la función de permisos
    const primeraRutaActiva = obtenerPrimeraRutaActiva();
    return primeraRutaActiva ? primeraRutaActiva.Ruta : '/proyectos';
};

/**
 * Verifica si una ruta está activa
 * @param ruta - La ruta a verificar
 * @returns true si la ruta está activa, false en caso contrario
 */
export const esRutaActiva = (ruta: string): boolean => {
    const rutaEncontrada = rutas.find(r => r.Ruta === ruta);
    return rutaEncontrada ? rutaEncontrada.Activa : false;
};

/**
 * Obtiene todas las rutas activas
 * @returns Array de rutas activas
 */
export const obtenerRutasActivas = (): IRuta[] => {
    return rutas.filter(ruta => ruta.Activa);
}; 